import React from 'react';
import Slider from 'react-slick';

import PricingBanner, { PricingDisplayMode } from 'elements/pricing/PricingBanner';
import { DesktopWrapper, SliderWrapper, PricingBannersContainer } from 'organisms/pricing/PricingPlanBanners.styles';
import LinkPro from 'elements/links/Link.pro';
import LinkBranded from 'src/elements/links/Link.branded';
import { PricingItemContentfulModel } from 'src/api/models/Pricing';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface PricingPlanBannersProps {
  pricingPlans: PricingItemContentfulModel[];
  pricingDisplayMode: PricingDisplayMode;
}

const PricingPlanBanners = ({ pricingPlans, pricingDisplayMode }: PricingPlanBannersProps): JSX.Element => {
  const getLink = (pricingPlan: PricingItemContentfulModel) => {
    if (pricingPlan.cta.variant.includes('primary')) {
      return <LinkBranded text={pricingPlan.cta?.text} caption={pricingPlan.cta?.helpText} captionJustify="center" url={pricingPlan.cta?.url}/>;
    }

    return <LinkPro text={pricingPlan.cta?.text} caption={pricingPlan.cta?.helpText} captionJustify="center" url={pricingPlan.cta?.url}/>;
  };

  const parsedPrices = pricingPlans.map(pricingPlan => ({
    id: pricingPlan.id,
    title: pricingPlan.title,
    subtitle: pricingPlan.subtitle,
    description: pricingPlan.description.description,
    bottomText: pricingPlan.disclaimer?.disclaimer,
    cta: getLink(pricingPlan),
    pricing: {
      monthly: pricingPlan.monthlyPrice,
      monthlyDescription: pricingPlan.monthlyPriceDescription,
      annual: pricingPlan.annualPrice,
      annualDescription: pricingPlan.annualPriceDescription,
      featuresTitle: pricingPlan.featuresTitle,
      features: pricingPlan.featuresList
    }
  }));

  const pricingItems = parsedPrices.map(({ id, ...pricing }) => (
    <PricingBanner key={id} {...pricing} priceDisplayMode={pricingDisplayMode}/>
  ));

  return (
    <PricingBannersContainer>
      <SliderWrapper>
        <Slider dots infinite={false} speed={300} slidesToShow={1}>
          {pricingItems}
        </Slider>
      </SliderWrapper>

      <DesktopWrapper>
        {pricingItems}
      </DesktopWrapper>
    </PricingBannersContainer>
  );
};

export default PricingPlanBanners;
